export default __webpack_public_path__ + "static/media/close-modal.c4fd058d.svg";